import { render } from "./VueMentionUpdate.vue?vue&type=template&id=b1201174&scoped=true"
import script from "./VueMentionUpdate.vue?vue&type=script&lang=js"
export * from "./VueMentionUpdate.vue?vue&type=script&lang=js"

import "./VueMentionUpdate.vue?vue&type=style&index=0&id=b1201174&lang=css"
import "./VueMentionUpdate.vue?vue&type=style&index=1&id=b1201174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1201174"]])

export default __exports__